// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"9a1214dca98788639478","339":"d8901b683e98879b79e2"}[chunkId] + ".js";
};